const STORAGE_KEY = 'ai-radar-favorites';

const read = (): string[] => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((value): value is string => typeof value === 'string') : [];
  } catch {
    return [];
  }
};

const write = (ids: string[]): void => localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(ids)]));

export const getFavorites = (): string[] => read();
export const isFavorite = (id: string): boolean => read().includes(id);
export const toggleFavorite = (id: string): boolean => {
  const ids = read();
  const next = ids.includes(id) ? ids.filter((item) => item !== id) : [...ids, id];
  write(next);
  window.dispatchEvent(new CustomEvent('ai-radar:favorites'));
  return next.includes(id);
};
